import React from "react";

import { AssignmentIndRounded, RestaurantRounded } from "@mui/icons-material";
import BusIcon from "@mui/icons-material/DirectionsBus";
import WhatshotIcon from "@mui/icons-material/Whatshot";
import { BottomNavigation, BottomNavigationAction, Box, Paper } from "@mui/material";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import useAuth from "../../config/context/authContext";
import useFirebase from "../../config/context/firebaseContext";
import storageKey from "../../config/storageKey";
import { GreyPallet } from "../../config/styles";
import { UtilComponents } from "../../config/util/utilComponents";

export default function HomePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { getConfig } = useFirebase();

  const { currentUserState } = useAuth();

  const DISABLE_BOTTOM_PAD = window.localStorage.getItem(storageKey.DISABLE_BOTTOM_PAD);

  const [activeTab, setActiveTab] = React.useState<number | false>(false);

  const handleSetBottomActive = () => {
    if (location.pathname.startsWith("/home/bus")) setActiveTab(1);
    else if (location.pathname.startsWith("/home/menu")) setActiveTab(2);
    else if (location.pathname.startsWith("/home/spott")) setActiveTab(3);
    else if (location.pathname.startsWith("/home/rating")) setActiveTab(4);
    else navigate("/home/bus");
  };

  React.useEffect(() => {
    handleSetBottomActive();
  }, []);

  React.useEffect(() => {
    handleSetBottomActive();
  }, [location]);

  return (
    <Box
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
      pt={"30px"}
      pb={"110px"}
    >
      {/* <MainBar /> */}

      <Box width={"90%"}>
        <Outlet />
      </Box>

      <Paper
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          borderTop: `3px solid ${GreyPallet.LightGhost}`,
          borderRadius: 0,
          zIndex: 100,
          "& .MuiSvgIcon-root": {
            fontSize: 30,
          },
        }}
      >
        <BottomNavigation
          showLabels
          value={activeTab}
          onChange={(event, newValue) => setActiveTab(newValue)}
          style={{
            padding: `5px 0px ${DISABLE_BOTTOM_PAD ? "5" : "20"}px 0px`,
            backgroundColor: "#fff",
          }}
        >
          <BottomNavigationAction
            value={1}
            onClick={() => navigate("/home/bus")}
            icon={<BusIcon />}
            label="Itinerário"
          />

          <BottomNavigationAction
            value={2}
            onClick={() => navigate("/home/menu")}
            icon={<RestaurantRounded />}
            label="Cardápio"
          />

          {(getConfig("enabled_spott") === true || UtilComponents.isStaff(currentUserState)) && (
            <BottomNavigationAction
              value={3}
              onClick={() => navigate("/home/spott")}
              icon={<WhatshotIcon />}
              label="Spott"
            />
          )}

          {(getConfig("enabled_rating") === true || UtilComponents.isStaff(currentUserState)) && (
            <BottomNavigationAction
              value={4}
              onClick={() => navigate("/home/rating")}
              icon={<AssignmentIndRounded />}
              label="Avaliação"
            />
          )}

          {/* <BottomNavigationAction
            value={5}
            onClick={() => navigate("/home/admin")}
            icon={<ForumRounded />}
          /> */}
          {/* <BottomNavigationAction
            value={5}
            onClick={() => navigate("/home/admin")}
            icon={<SchoolRounded />}
          /> */}
        </BottomNavigation>
      </Paper>
    </Box>
  );
}
